import { useEffect, FC } from 'react';
import qs from 'qs';
import { useLocation } from 'react-router-dom';

import { CLIENT_BASE_URL, LOCAL_STORAGE_TYPES } from '../../constants';
import useLocalStorage from '../../hooks/localstorage';

const SocialAuth: FC = () => {
  const windowLocation = useLocation();

  const { get } = useLocalStorage();

  const getAuthorizationStatus = (authParam: boolean): 'success' | 'error' => {
    if (authParam === true) {
      return 'success';
    }
    return 'error';
  };

  const hashToken =
    get(LOCAL_STORAGE_TYPES.SOCIAL_AUTH_TOKEN) &&
    Object.keys(get(LOCAL_STORAGE_TYPES.SOCIAL_AUTH_TOKEN) || {}).length === 0
      ? get(LOCAL_STORAGE_TYPES.SOCIAL_AUTH_TOKEN)
      : windowLocation.hash;

  const { channel } =
    qs.parse(windowLocation.search?.replace('?', '').replace('#', '') || '') ??
    {};
  const { access_token: accessToken } =
    qs.parse(hashToken ? hashToken.replace('#', '').replace('#', '') : '') ??
    {};

  useEffect(function socialAuthHandler() {
    (window.opener as typeof window)?.postMessage(
      {
        type: 'social-auth',
        auth: getAuthorizationStatus(/#access_token=/gi.test(hashToken || '')),
        beacon: /#beacon=open/gi.test(hashToken || ''),
        denied: accessToken === 'sparrow',
        channel,
      },
      CLIENT_BASE_URL
    );
    window.close();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default SocialAuth;
